import {Hr} from "@irati/ui/src/Layout"
import {ButtonLink} from "@irati/ui/src/Link"
import {Body, H2, H4} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import React from "react"
import {PillPointsConversion} from "@irati-web/wallet/src/components/PillPointsConversion"
import Flex from "@irati/ui/src/Flex"
import AutomationsList from "../../components/AutomationsList"

interface Props extends InjectIntlProps {}
const AutomationHome: React.FC<Props> = (props) => {
  const {formatMessage} = props
  return (
    <>
      <H2 marginBottom={1}>
        <FormattedMessage id="admin.automation.homeHeader" />
      </H2>
      <Body maxWidth="unset" marginBottom={2}>
        <FormattedMessage id="admin.automation.homeSubtitle" />
      </Body>
      <ButtonLink href={formatMessage({id: "admin.automation.home.learnMoreLink"})} target="_blank">
        <FormattedMessage id="platform.ui.banner.cta.text" />
      </ButtonLink>
      <Hr marginBottom={4} marginTop={4} />
      <Flex alignItems="baseline">
        <H4 marginBottom={3} marginRight={1}>
          <FormattedMessage id="admin.automation.automationsListSectionHeader" />
        </H4>
        <PillPointsConversion />
      </Flex>
      <AutomationsList />
    </>
  )
}

export default injectIntl(AutomationHome)
